import  React, { Component } from 'react'
import  { Marker }  from 'react-leaflet'
import  { divIcon } from 'leaflet'

export default class Listing extends Component {

  formatPrice(numStr) {
    const num = Number(numStr)
    let abbr = ''
    if (num >= 10000000) { // 10M
      abbr = Math.round(num / 1000000) + 'M'
    } else if (num >= 1000000) { // 1M
      abbr = (num / 1000000).toFixed(1) + 'M'
    } else if (num >= 100000) { // 100K
      abbr = Math.round(num / 1000) + 'K'
    } else if (num >= 1000) {
      abbr = (num / 1000).toFixed(1) + 'K'
    } else if (num <= 1) {
      return '🏠'
    } else {
      abbr = Math.round(num).toString()
    }
    return '$' + abbr.replace(/\.0/, '')
  }

  listing() {
    return {
      lat:    this.props.action._source.latitude,
      lon:    this.props.action._source.longitude,
      price:  this.props.action._source.price,
    }
  }

  classesForIcons() {
    var classes = ['sidx-map-listing']
    switch(this.props.action.action_type) {
      case 'ViewedListing': classes.push('sidx-map-marker-viewed-listing'); break
      case 'SavedListing':  classes.push('sidx-map-marker-saved-listing');  break
      case 'Comment':       classes.push('sidx-map-marker-comment');        break
      case 'Reaction':      classes.push('sidx-map-marker-reaction');       break
      case 'HiddenListing': classes.push('sidx-map-marker-hidden-listing'); break
      default:              classes.push('sidx-map-marker-fallback')
    }
    return classes.join(' ')
  }

  fetchZIndexOffset() {
    switch(this.props.action.action_type) {
      case 'ViewedListing': return 6000
      case 'SavedListing':  return 9000
      case 'Comment':       return 7000
      case 'Reaction':      return 8000
      case 'HiddenListing': return 0
      default:              return 0
    }
  }

  render() {
    const icon = divIcon({
      className:      this.classesForIcons(),
      html:           this.formatPrice(this.listing().price),
      iconSize:       [38, 19],
      iconAnchor:     [19, 26],
      tooltipAnchor:  [0, -26],
    })
    const {lat, lon} = this.listing()
    const position = [lat, lon]

    return (
      <Marker icon={icon} position={position} zIndexOffset={this.fetchZIndexOffset()} />
    )
  }

}



// WEBPACK FOOTER //
// client/components/map/listing.js